import { RiSparkling2Line } from "react-icons/ri";

export const LinkedinPostEditorHeader = () => {
  return (
    <div className="flex flex-col items-center pt-[50px] md:pt-[100px] gap-1">
      <div
        className="w-fit rounded px-4 py-1 relative rotate-3"
        style={{
          background: "linear-gradient(90deg, #5892ea 0%, #2569cf 100%)",
        }}
      >
        <span className="text-white text-center font-[Inter] text-xs not-italic font-bold leading-[normal] capitalize flex items-center justify-center gap-2">
          Exactly as on Linkedin!
          <div className="text-sm">😎</div>
        </span>
        <RiSparkling2Line
          size={20}
          color="#FFDD55"
          className=" absolute -top-2 -left-2 animate-pulse"
        />
      </div>
      <div className="flex flex-col items-center gap-2 self-stretch relative p-4 ">
        <h1
          className="text-[color:var(--Shade-Wh1te,#FFF)] text-center text-3xl md:text-[44px] not-italic font-bold leading-[normal]"
          style={{
            background: "linear-gradient(90deg, #FFF 47.5%, #6DA0ED 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Perfect Your LinkedIn Post Before It Goes Live
        </h1>
        <span className="text-[#919191] text-center font-[Inter] not-italic font-normal leading-[28px] md:w-1/2 text-sm md:text-base">
          Preview your LinkedIn post to ensure your key message stays visible
          before the 'see more' cut-off and captures attention instantly. Write,
          preview, and refine effortlessly. Share a preview link with your team
          for feedback, and every edit generates a new shareable link for
          clarity
        </span>
      </div>
    </div>
  );
};
